import React from "react";

const faq2 = () =>{
  return(
    <>
      <p>
        Du väljer själv i <i>din</i>BiZ.
      </p>
      <p>
        Enklast för ny användare <br/>
        – välj menyknapp 1 – UtbudsMix.
      </p>
      <p>
        Välj bolagsform för aktuellt år. Första 
        gången förslagsvis år 1. (Fritt att ändra).
      </p>
      <p>
        Ange sedan samtliga erbjudanden som 
        marknadsförs eller planeras marknadsföras 
        – en rad per erbjudande.
      </p>
      <p>
        För korrekt analys och lönekalkyl krävs att 
        du också anger samtliga kända fasta 
        kostnader och eventuella åtgärdskostnader 
        – under respektive menyknapp.
      </p>
      <p>
        Du kan fritt välja mellan menyknapparna 
        och fritt fylla på och justera dina data – 
        även mellan olika analystillfällen.
      </p>
      <p>
        Knappen för lönekalkyl väljer du för att 
        justera skattesatser efter individuella 
        behov. För de allra flesta användare räcker 
        schablonen väl. <i>Justera <u>endast</u> efter du 
        säkrat dina nya uppgifter och siffror med 
        Skatteverket.</i>
      </p>
    </>
  );
}
export default faq2;